import React, { useEffect, useState } from 'react'
import cn from 'classnames'
import _range from 'lodash/range'
import _isEmpty from 'lodash/isEmpty'
import Icon from '../Icon2/Icon'
import Dropdown from '../DropDown/Dropdown'
import { isNextMonthDisabled, isPrevMonthDisabled, months, getYearsPeriod, headerTestIds } from './helpers'
import format from 'date-fns/format'
import addYears from 'date-fns/addYears'
import subYears from 'date-fns/subYears'
import getYear from "date-fns/getYear";


const Header = props => {
  const {
    date,
    changeYear,
    changeMonth,
    decreaseMonth,
    increaseMonth,
    prevMonthButtonDisabled,
    nextMonthButtonDisabled,
    minDate,
    maxDate,
    maxAllowedDate,
    minAllowedDate,
    calenderView,
    setCalenderView,
    numberOfYearsToRender,
    version
  } = props
  const years = _range(minDate?.getFullYear(), maxDate?.getFullYear(), 1)

  const yearList = [
    ...years.map(year => ({
      key: year,
      label: year,
      action: () => {
        changeYear(year)
      },
      default: year === date.getFullYear(),
    })),
  ]
  const monthList = [
    ...months.map(month => ({
      key: month,
      label: month,
      action: () => {
        changeMonth(months.indexOf(month))
      },
      default: month === months[date.getMonth()],
    })),
  ]
  const [currentRangeYear, setCurrentRangeYear] = useState(date || new Date())

  const prevButtomOnKeydownHandler = (e: any) => {
    if (e.key === "Enter") {
      prevButtonClickHandler(e)
    }
  }

  const nextButtomOnKeydownHandler = (e: any) => {
    if (e.key === "Enter") {
      nextButtonClickHandler(e)
    }
  }

  const prevButtonClickHandler = (e: any) => {
    e.stopPropagation()
    if (calenderView === "year" && version === "v2") {
      const updatedYear = subYears(currentRangeYear, numberOfYearsToRender)
      setCurrentRangeYear(updatedYear)
      changeYear(getYear(updatedYear))
    } else if (calenderView === "month" && version === "v2") {
      changeYear(getYear(subYears(date, 1)))
    } else {
      decreaseMonth()
    }
  }

  const nextButtonClickHandler = (e: any) => {
    e.stopPropagation()
    if (calenderView === "year" && version === "v2") {
      const updatedYear = addYears(currentRangeYear, numberOfYearsToRender)
      setCurrentRangeYear(updatedYear)
      changeYear(getYear(updatedYear))
    } else if (calenderView === "month" && version === "v2") {
      changeYear(getYear(addYears(date, 1)))
    } else {
      increaseMonth()
    }
  }

  const renderHeaderLabel = (headerLabel: any, labelView?: string) => {
    const headerLabelClickHandler = () => {
      if (labelView) setCalenderView(labelView)
    }
    const onKeyDownHandlerHeaderLabel = (e: any) => {
      if (e.key === "Enter" || e.key === " ") {
        headerLabelClickHandler()
      }
    }
    return (
      <div data-test-id={labelView && headerTestIds[labelView]} tabIndex={calenderView === "year" ? -1 : 0} onKeyDown={onKeyDownHandlerHeaderLabel} className='Datepicker__header-label' onClick={headerLabelClickHandler}>{headerLabel}</div>
    )
  }

  const RenderHeaderDom = () => {
    if (version === "v2") {
      if (calenderView === "month") return renderHeaderLabel(selectedYear, "year")
      else if (calenderView === "year") return renderHeaderLabel(`${startPeriod} - ${endPeriod}`)
      else return (<div className='flex'>
        {renderHeaderLabel(selectedMonth, "month")}
        {renderHeaderLabel(selectedYear, "year")}
      </div>)
    } else {
      return (<>
        <Dropdown type="select" list={monthList} closeAfterSelect={true} testId="cs-datepicker-select-month" />
        {!_isEmpty(yearList) && <Dropdown type="select" list={yearList} closeAfterSelect={true} testId="cs-datepicker-select-year" />}
      </>)
    }
  }

  const selectedMonth = format(new Date(date).getTime() ? date : new Date(), 'MMMM');
  const selectedYear = format(new Date(date).getTime() ? date : new Date(), 'yyyy');
  const { startPeriod, endPeriod } = getYearsPeriod(currentRangeYear, numberOfYearsToRender);
  const disablePrevMonth = prevMonthButtonDisabled || isPrevMonthDisabled(date, minAllowedDate ? minAllowedDate : minDate)
  const disabledNextMonth = nextMonthButtonDisabled || isNextMonthDisabled(date, maxAllowedDate ? maxAllowedDate : maxDate)

  return (
    <div className={`Datepicker__custom-header ${version === 'v2' ? 'Datepicker__custom-header--v2' : ''}`}>
      <button
        className={cn('Datepicker__header-controls', { disabled: disablePrevMonth })}
        onKeyDown={prevButtomOnKeydownHandler}
        onClick={prevButtonClickHandler}
        disabled={disablePrevMonth}
        type="button"
        aria-label='Previous Month'
        data-test-id="cs-datepicker-previous-month"
      >
        {version === 'v2' ? <Icon version='v2' icon="CaretCircleLeft" /> : <Icon icon="LeftArrowGray" />}
      </button>
      <RenderHeaderDom />
      <button
        className={cn('Datepicker__header-controls', { disabled: disabledNextMonth })}
        onKeyDown={nextButtomOnKeydownHandler}
        onClick={nextButtonClickHandler}
        disabled={disabledNextMonth}
        type="button"
        aria-label='Next Month'
        data-test-id="cs-datepicker-next-month"
      >
        {version === 'v2' ? <Icon version='v2' icon="CaretCircleRight" /> : <Icon icon="RightArrowGray" />}
      </button>
    </div>
  )
}

export default Header